<mc-window title="Column Settings" height="700" left="100" top="-400" width="600" is-draggable="true" is-resizable="true" [toggleOpen]="columnSettingsDialogOpened" (openChange)="closeColumnSettings($event)">
    <div slot="content" class="column-settings-dialog">
        <div class="content">
            <div class="filter">
                <input type="text" [(ngModel)]="columnSettingsFilterText" (input)="setColumnSettingsFilteredForDialog()" placeholder="Filter by column name">
            </div>
            <div class="column-settings-list">
                <div class="column-headers">
                    <div class="moveTop"></div>
                    <div class="reorder" title="Reorder Columns"></div>
                    <div class="name" title="Sort By Name">
                        Name
                    </div>
                    <div class="visibility" title="Sort By Visibility">
                        Visible
                    </div>
                    <div class="sum" title="Sort By Sum">
                        Sum
                    </div>
                    <div class="average" title="Sort By Average">
                        Average
                    </div>
                </div>
                <div class="column-settings-list">
                    <div class="column-headers">
                        <div class="moveTop"></div>
                        <div class="reorder"></div>
                        <div class="name"></div>
                        <div class="visibility">
                            <input type="checkbox" name='Visible' id='visible' [checked]="allVisible"
                                   (change)="selectForCheckBox('visibility', $event)">
                            <label for="Visible" style='font-size: 11px !important;'>
                                {{ allVisible ? 'Uncheck All' : 'Check All' }}
                            </label>
                        </div>
                        <div class="sum">
                            <input type="checkbox" name='Sum' [checked]="allSum"
                                   (change)="selectForCheckBox('sum', $event)">
                            <label for="Sum" style='font-size: 11px !important;'>
                                {{ allSum ? 'Uncheck All' : 'Check All' }}
                            </label>
                        </div>
                        <div class="average">
                            <input type="checkbox" name='Average' [checked]="allAverage"
                                   (change)="selectForCheckBox('average', $event)">
                            <label for="Average" style='font-size: 11px !important;'>
                                {{ allAverage ? 'Uncheck All' : 'Check All' }}
                            </label>
                        </div>
                    </div>
                </div>
                <div cdkDropList (cdkDropListDropped)="cdkDrop($event)">
                    <div *ngFor="let columnSetting of columnSettingsFilteredForDialog; let i = index" class="column" [class.visible]="columnSetting.visible"
                         cdkDrag [cdkDragData]="columnSetting" [cdkDragBoundary]="'.content'">
                        <div *cdkDragPreview style="margin: -10px 0 0 -10px; min-width: 50px;">
                            <div class="reorder" style="display: inline-block;">
                                <span title="Reorder" class="icon button">
                                    <i class="icon-ui-drag-horizontal"></i>
                                </span>
                            </div>
                            <span class="name" style="text-wrap: none;">
                                {{ columnSetting.displayName }}
                            </span>
                        </div>
                        <div class="moveTop">
                            <button title="Move to Top" class="btn btn-transparent btn-small" [disabled]="i === 0 || columnSettingsSortField !== 'order'" (click)="moveItemToTop(i)" [title]="columnSettingsSortField !== 'order' ? 'Sort by Reorder Columns to reorder' : ''">
                                <i class="icon-ui-up-arrow"></i>
                            </button>
                        </div>
                        <div class="reorder" cdkDragHandle [class.disabled]="columnSettingsSortField !== 'order'" [title]="columnSettingsSortField !== 'order' ? 'Sort by Reorder Columns to reorder' : ''">
                            <span title="Reorder" class="icon button">
                                <i class="icon-ui-drag-horizontal"></i>
                            </span>
                        </div>
                        <div class="name" (click)="toggleColumnVisibility(columnSetting)" [title]="columnSetting.name">
                            {{ columnSetting.displayName }}
                        </div>
                        <div class="visibility">
                            <input type="checkbox" [(ngModel)]="columnSetting.visible" (change)="columnSettingChange()">
                        </div>
                        <div class="sum">
                            <input type="checkbox" [(ngModel)]="columnSetting.calculateSum" *ngIf="columnSetting.isNumeric"
                                   (change)="columnSettingChange()">
                        </div>
                        <div class="average">
                            <input type="checkbox" [(ngModel)]="columnSetting.calculateAverage"
                                   *ngIf="columnSetting.isNumeric" (change)="columnSettingChange()">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mc-window>

<div class="table-container" [style.width.px]="width" *ngIf="opened">
    <div class="table-toolbar">
        <div *ngIf="enableMultiTabs" class="column-sort-order" style="padding-right:15px; border-right:2px solid white;">
            <span class="text">Tabs:</span>
            <select [(ngModel)]="curMultiTab" (change)="changeCurMultiTab()">
                <option *ngFor="let option of multiTabsArr" value="{{ option.layerId }}">{{ option.name }}</option>
            </select>
        </div>
        <div class="title">
            <span class="text">
                {{ mapcoreProps[titleProperty] }}
            </span>
        </div>
        <div class="toolbar">
            <div class="column-sort-order">
                <span class="text">Sort Order:</span>
                <select [(ngModel)]="columnSortOrder" (change)="columnSettingChange()">
                    <option value="alphabetical">Alphabetical</option>
                    <option value="database">Database</option>
                    <option [hidden]="hideCustomSort" value="custom">Custom</option>
                </select>
            </div>
            <div class="row-count-container">
                <div class="row-count" *ngIf="rowCount !== ''">
                    <span class="text">Row Count:</span>
                    <span class="value">{{ rowCount }}</span>
                    <span *ngIf="fullData.length >= defaultRecordsFetched" title="Maximum rows returned, selecting less columns or filtering the layer is recommended">?</span>
                </div>
            </div>
            <div class="loading" *ngIf="loading && rowCount === ''">
                <span>Loading...</span>
            </div>
            <div class="rows-selected">
                <span class="value" *ngIf="this.selectedObjectIds.length">
                    ({{ this.selectedObjectIds.length }})
                </span>
            </div>
            <div *ngIf="recordEditorEnabled && (canUpdate || canDelete)" class="updateOrDeleteRecord clickable" [class.disabled]="selectedObjectIds.length !== 1" (click)="triggerOpenEditor(true)">
                <span title="Edit Selected Feature" class="icon button">
                    <i class="icon-ui-edit"></i>
                </span>
            </div>
            <div *ngIf="recordEditorEnabled && canInsert" class="addRecord clickable" (click)="triggerOpenEditor()">
                <span title="Add Feature" class="icon button">
                    <i class="icon-ui-plus"></i>
                </span>
            </div>
            <div class="toggle-rows-selected clickable" (click)="toggleShowSelected()"
                 [class.disabled]="selectedObjectIds.length === 0">
                <span class="toggle-show-selected icon button" title="Toggle Show Selected">
                    <i class="icon-ui-checkbox-checked" [hidden]="!showSelected"></i>
                    <i class="icon-ui-checkbox-unchecked" [hidden]="showSelected"></i>
                </span>
            </div>
            <div class="map clickable" (click)="mapSelectedFeatures()"
                 [class.disabled]="selectedObjectIds.length === 0">
                <span title="Map Selected Features" class="icon button">
                    <i class="icon-ui-maps"></i>
                </span>
            </div>
            <div class="select clickable" (click)="selectFromMap()">
                <mc-lasso-tool-ng id="mcLassoTool" #lassoTool></mc-lasso-tool-ng>
                <span title="Select From Map" class="icon button">
                    <i class="icon-ui-authorize"></i>
                </span>
            </div>
            <div class="download clickable" (click)="download()">
                <span title="Download Excel Spreadsheet" class="icon button">
                    <i class="icon-ui-download"></i>
                </span>
            </div>
            <div class="column-options clickable" (click)="toggleColumnSettings()">
                <span title="Column Options" class="icon button">
                    <i class="icon-ui-settings"></i>
                </span>
            </div>
            <div *ngIf="!enableMultiTabs" class="close clickable" (click)="close()">
                <span title="Close" class="icon button">
                    <i class="icon-ui-close"></i>
                </span>
            </div>
            <div *ngIf="enableMultiTabs" class="close clickable">
                <span title="Close" class="icon button" (click)="toggleCloseOptions()">
                    <i class="icon-ui-close"></i>
                </span>
                <div class="close-dropdown" *ngIf="showCloseOptions">
                    <a (click)="close()">Close Tab</a>
                    <a (click)="closeAll()">Close All Tabs</a>
                </div>
            </div>
        </div>
    </div>
    <div class="table">
        <mc-table-ng canResizeColumns="true"
                     canSelectRows="true"
                     (columnResizeEvent)="onColumnResize($event)"
                     [columnSettings]="tableColumnSettings"
                     columnSortMode="multiple"
                     [data]="gridDataResult"
                     [dataIDPropertyName]="idPropertyName"
                     (filterEvent)="onFilterEvent($event)"
                     [hasRowDetails]="hasChildTables"
                     isColumnSizeFixed="true"
                     isFilterEnabled="true"
                     [isLoading]="loading"
                     [pageSize]="pageSize"
                     [rowDetailsTemplate]="rowDetailsTemplate"
                     (rowSelectionEvent)="onRowSelection($event)"
                     [selectedRowIds]="selectedObjectIds"
                     showColumnHeaders="true"
                     [showFooter]="showFooter"
                     (sortEvent)="onSortEvent($event)"
                     tableCellWrapMode="ellipsis"
                     [tableFooterTemplate]="tableFooterTemplate"
                     tableHeight="335px">
            <ng-template #rowDetailsTemplate let-childData>
                <mc-additional-information-ng [layerId]="systemLayerId" [childTables]="layerChildTables" [feature]="childData"></mc-additional-information-ng>
            </ng-template>
        </mc-table-ng>
    </div>
</div>
